import script from "./AppSummaryAlt.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSummaryAlt.vue?vue&type=script&setup=true&lang=js"

import "./AppSummaryAlt.vue?vue&type=style&index=0&id=feaeea0c&lang=scss"

const __exports__ = script;

export default __exports__